import { render, staticRenderFns } from "./RationsTableRowBodyItem.vue?vue&type=template&id=53dd5034&lang=pug"
import script from "./RationsTableRowBodyItem.vue?vue&type=script&lang=js"
export * from "./RationsTableRowBodyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports